import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils';
export const tabsTriggerVariants = cva(cn(['inline-flex items-center justify-center whitespace-nowrap', 'data-[state=active]:text-strong text-assistive disabled:text-disabled', 'data-[state=active]:border-strong border-b-2 border-transparent ', 'data-[state=active]:hover:bg-strong-alternative hover:bg-alternative', 'rounded-tr-xs rounded-tl-xs']), {
  variants: {
    size: {
      md: 'max-h-[52px] min-w-[80px] p-sm text-heading-md-bold',
      sm: 'max-h-[32px] min-w-[64px] px-sm py-2xs text-body-lg-bold'
    }
  },
  defaultVariants: {
    size: 'md'
  }
});
export interface TabsTriggerProps extends React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>, VariantProps<typeof tabsTriggerVariants> {}
const TabsTrigger = React.forwardRef<React.ElementRef<typeof TabsPrimitive.Trigger>, TabsTriggerProps>(({
  className,
  size,
  ...props
}, ref) => <TabsPrimitive.Trigger ref={ref} className={cn(tabsTriggerVariants({
  size
}), className)} {...props} />);
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
export { TabsTrigger };